export default __webpack_public_path__ + "173f4b7b63f134fff61ea6ae063125e5.jpg";